<template>
  <div :class="{ 'text-brand-900': isChecked }">
    <div class="flex gap-2 items-center">
      <template v-if="identifier.display_name">
        <span>{{ identifier.display_name }}</span>
        <span class="text-gray-400">/</span>
      </template>
      <app-badge
        color="neutral"
        size="sm"
      >
        {{ identifier.kind }}
      </app-badge>
      <span :class="{ 'text-gray-700': !isChecked }">{{ identifier.value }}</span>
    </div>
    <div
      v-if="(isUnlinked && !isChecked) || identifier.transfer_party"
      class="identifier-recipient-meta"
    >
      <span v-if="isLinkedToTargetRecipient">Linked to</span>
      <app-icon
        v-if="isUnlinked || isLinkedToTargetRecipient"
        :name="isChecked ? 'link-four' : 'link-broken-two'"
        :class="isChecked ? 'text-brand-600' : 'text-gray-600'"
        size="sm"
      />
      <span
        v-if="identifier.transfer_party"
        :class="{ 'line-through text-gray-400': isReassigningToTargetRecipient }"
        data-sentry-unmask
      >
        {{ identifier.transfer_party.business_name }} / {{ identifier.transfer_party.currency_alpha_code }}
      </span>
      <span v-else-if="isUnlinked && !isReassigningToTargetRecipient">No beneficiary linked</span>
    </div>
    <div
      v-if="isReassigningToTargetRecipient"
      class="identifier-recipient-meta"
      data-sentry-unmask
    >
      <app-icon
        name="link-four"
        size="sm"
        class="text-brand-600"
      />
      <p>{{ targetRecipient.business_name }} / {{ targetRecipient.currency_alpha_code }}</p>
    </div>
  </div>
</template>

<script setup>
import AppBadge from '@/components/ui/AppBadge.vue';
import { computed } from 'vue';

const props = defineProps({
  identifier: {
    type: Object,
    required: true,
  },
  targetRecipient: {
    type: Object,
    default: () => ({}),
  },
  isChecked: {
    type: Boolean,
    default: false,
  },
});

const isLinkedToTargetRecipient = computed(() => {
  if (props.targetRecipient?.provider_entity_id === undefined) return false;
  return props.identifier.transfer_party?.provider_entity_id === props.targetRecipient?.provider_entity_id;
});

const isReassigningToTargetRecipient = computed(() => {
  return !isLinkedToTargetRecipient.value && props.isChecked;
});

const isUnlinked = computed(() => !props.identifier.transfer_party);
</script>

<style scoped>
@reference '@/assets/main.css';

.identifier-recipient-meta {
  @apply text-xs mt-1 flex items-center gap-2;
}
</style>
